import React from 'react';
import {motion} from 'framer-motion';
import {Link} from 'react-router-dom';
import {siteData} from '../../data/content';
import * as FiIcons from 'react-icons/fi';
const {FiMapPin,FiPhone,FiArrowRight,FiAward}=FiIcons;

const HERO_IMG="https://images.unsplash.com/photo-1601362840469-51e4d8d58785?auto=format&fit=crop&q=80";
const BOOKING_URL="https://app.urable.com/virtual-shop/cFNwotdAvEx76Evup5X1";

export default function Hero() {
  return ( 
    <div className="relative min-h-screen flex items-center justify-center bg-slate-950 overflow-hidden"> 
      {/* Background Image & Overlay */} 
      <div className="absolute inset-0 z-0"> 
        <img src={HERO_IMG} alt="Premium Auto Detailing Jacksonville FL" className="w-full h-full object-cover opacity-35 scale-105" /> 
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/85 to-slate-950/40" /> 
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-slate-950/30" /> 
      </div> 

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pt-24 pb-16"> 
        <div className="max-w-3xl"> 
          <motion.div initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} className="inline-flex flex-wrap items-center gap-3 mb-6" > 
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-900/30 border border-blue-500/30 text-blue-400 text-xs font-bold uppercase tracking-widest"> 
              <FiMapPin className="text-sm" /> Jacksonville,FL 
            </span> 
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-800/80 border border-slate-700/50 text-slate-300 text-xs font-bold uppercase tracking-widest"> 
              <FiAward className="text-sm text-blue-500" /> Veteran Owned 
            </span> 
          </motion.div> 

          <motion.h1 initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{delay: 0.1}} className="text-5xl md:text-7xl font-black text-white leading-[1.05] uppercase tracking-tighter mb-6 drop-shadow-lg" > 
            Jacksonville's<br /> 
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-blue-600"> Elite Detailing </span> 
          </motion.h1> 

          <motion.p initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{delay: 0.2}} className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl font-medium leading-relaxed" > 
            From a quick Fresh Ride to a full Elite Detail with ceramic protection — we bring showroom-quality results directly to your driveway. 
          </motion.p> 

          <motion.div initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{delay: 0.3}} className="flex flex-col sm:flex-row gap-4" > 
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-sm font-bold tracking-wide uppercase text-sm bg-blue-600 text-white hover:bg-blue-500 shadow-[0_4px_24px_rgba(37,99,235,0.4)] hover:shadow-[0_4px_30px_rgba(37,99,235,0.6)] transform hover:-translate-y-0.5 transition-all" > 
              Book Now <FiArrowRight /> 
            </a> 
            <a href={`tel:${siteData.business.phoneTel}`} className="inline-flex items-center justify-center gap-2 px-7 py-4 border-2 border-slate-600 text-white font-bold hover:border-blue-500 hover:text-blue-400 transition-all rounded-sm uppercase tracking-wide text-sm" > 
              <FiPhone className="text-sm" /> Call Now 
            </a> 
            <Link to="/packages" className="inline-flex items-center justify-center gap-2 px-7 py-4 border-2 border-slate-700/50 text-slate-400 font-bold hover:border-slate-500 hover:text-white transition-all rounded-sm uppercase tracking-wide text-sm" > 
              View Packages 
            </Link> 
          </motion.div> 

          <motion.div initial={{opacity: 0}} animate={{opacity: 1}} transition={{delay: 0.5}} className="mt-14 pt-8 border-t border-slate-800/80" > 
            <p className="text-slate-500 text-xs uppercase tracking-widest mb-4 font-bold">Our Packages</p> 
            <div className="flex flex-wrap gap-3"> 
              {['Fresh Ride — From $60','Gloss Boss — From $150','Elite Detail — From $250'].map((pkg,i)=> ( 
                <span key={i} className="px-4 py-2 bg-slate-900/80 border border-slate-800 text-slate-300 text-xs font-semibold rounded-sm"> 
                  {pkg} 
                </span> 
              ))} 
            </div> 
          </motion.div> 
        </div> 
      </div> 
    </div> 
  );
}